export var GOOGLE_LOGIN_LINK = 'https://accounts.google.com/signin/v2/identifier?continue=https%3A%2F%2Fmail.google.com%2Fmail%2F&service=mail&sacu=1&rip=1&flowName=GlifWebSignIn&flowEntry=ServiceLogin';

var hasPgaComEmail = function hasPgaComEmail(email) {
  return email ? email.endsWith('@pga.com') : false;
};

var handleMailClick = function handleMailClick(_ref) {
  var meEmailMigrationData = _ref.meEmailMigrationData,
      setModalType = _ref.setModalType,
      setOpen = _ref.setOpen;

  var _ref2 = meEmailMigrationData || {},
      emailAddress = _ref2.emailAddress,
      doNotShowAgain = _ref2.doNotShowAgain;

  if (hasPgaComEmail(emailAddress)) {
    if (doNotShowAgain) {
      window.location.assign(GOOGLE_LOGIN_LINK);
    } else {
      setModalType('gmailLogin');
      setOpen(true);
    }
  } else {
    setModalType('gmailSignup');
    setOpen(true);
  }
};

export default handleMailClick;